import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';

@Injectable({
    providedIn: 'root'
})
export class NotificationOnExitGuard implements CanDeactivate<Observable<boolean> | Promise<boolean> | boolean> {
    constructor(private store: Store<appStore.AppState>) {
    }

    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
        this.store.dispatch(new appStore.CheckNotificationOnExit());

        return true;
    }
}
